/* eslint-disable prettier/prettier */
import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { RequestedItem } from 'models/requestHistory';
import ResponseScreen, { BackgroundTypes, IconTypes } from 'screens/components/ResponseScreen';
import { htmlT } from 'utils/generic';

interface Props {
  show: boolean;
  travel?: RequestedItem;
  onConfirm: () => void;
}

const SolicitationApproved = ({ show, travel, onConfirm }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <ResponseScreen
      show={show}
      text={t('solicitationApproved.text')}
      subTitle={t('solicitationApproved.subText')}
      subText={htmlT(t, 'solicitationApproved.textDescription', {
        user: travel?.userName || '',
      })}
      background={BackgroundTypes.Cloud}
      icon={IconTypes.Airplane}
      buttonOnClick={onConfirm}
      buttonText={t('solicitationApproved.buttonText')}
    />
  );
};

export default SolicitationApproved;
